module.exports = __webpack_public_path__ + "img/scale.6701bc16.svg";